import React, { useContext, useCallback } from 'react';
import { ViewModelForm } from 'gw-portals-viewmodel-react';
import { TranslatorContext } from '@jutro/locale';
import { useCommonTagManager, useGlobalPhoneLayer } from 'nfum-portals-utils-react';
import metadata from './CallOrContactInfo.metadata.json5';
import styles from './CallOrContactInfo.module.scss';
import messages from './CallOrContactInfo.messages';

function CallOrContactInfo(props) { /* NOSONAR: pure declarative usage */
    const translator = useContext(TranslatorContext);
    const {
        pushLinkClickInfo
    } = useCommonTagManager();
    const { getPhoneNumber } = useGlobalPhoneLayer();

    const {
        header,
        description,
        producerDesc,
        producerTele,
        isBespoke,
        showAgencyDetails,
        showAlternativeText,
        phoneNumber,
        isMutualDirect = true // defaulted to Mutual Direct as a contact
    } = props;
    const hasAgencyDetails = !!(producerDesc && producerTele);

    const onRequestCallback = useCallback(() => {
        const url = 'https://www.nfumutual.co.uk/contact-us/home-ce-call-back/';
        pushLinkClickInfo(translator(messages.requestForCallbackText), url);
        window.open(url, '_blank');
    }, [pushLinkClickInfo, translator]);

    const onFindAgencyClicked = useCallback(() => {
        const url = 'https://www.nfumutual.co.uk/agent-offices/';
        pushLinkClickInfo(translator(messages.contactYourAgency), url);
        window.open(url, '_blank');
    }, [pushLinkClickInfo, translator]);
    const overrideProps = {
        referralMessageTitle: {
            visible: header != null,
            content: translator(header)
        },
        referralContentMessage: {
            visible: description != null,
            content: translator(description)
        },
        callTimingsContainer: {
            visible: isMutualDirect
        },
        findYourAgencyContainer: {
            visible: !hasAgencyDetails && !isMutualDirect
        },
        contactYourAgencyContainer: {
            visible: hasAgencyDetails && !isMutualDirect
        },
        alteranteContactOptionContainer: {
            visible: (!showAgencyDetails && !isBespoke) || showAlternativeText
        },
        contactYourAgencyText: {
            content: producerDesc ? `${producerDesc}` : ''
        },
        callAgencyPhone: {
            content: `${translator(messages.call)} ${producerTele || phoneNumber || getPhoneNumber()}`,
            className: `contactYourAgencyCallus orig-${producerTele?.replaceAll(' ', '') || phoneNumber?.replaceAll(' ', '') || getPhoneNumber()?.replaceAll(' ', '')}`
        },
        findYourAgencyButton: {
            onClick: onFindAgencyClicked
        },
        moreInfoButton: {
            onClick: onFindAgencyClicked
        },
        requestForCallbackText: {
            onClick: onRequestCallback
        },
        callBackButton: {
            onClick: onRequestCallback
        },
        callTimingsTitle: {
            content: `${translator(messages.call)} ${phoneNumber || getPhoneNumber()}`,
            className: `orig-${phoneNumber?.replaceAll(' ', '') || getPhoneNumber()?.replaceAll(' ', '')}`
        }
    };

    const resolvers = {
        resolveClassNameMap: styles,
    };

    return (
        <ViewModelForm
            uiProps={metadata.componentContent}
            overrideProps={overrideProps}
            classNameMap={resolvers.resolveClassNameMap}
        />
    );
}

export default CallOrContactInfo;
